import React, { Component } from "react";
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout.jsx';
import { Breadcrumb, Col, Container, Row, Button } from 'react-bootstrap';
import Link, { LinkTo } from '../../PageLayout/Link/Link';
import ApiService from '../../Services/ApiService';
import ReactRouterPropTypes from 'react-router-prop-types';
import Markdown from './component/Markdown';
import UserService from '../../Services/UserService';
import ProjectService from '../../Services/ProjectService';
import AuthorizeService from '../../ApiAuthorization/AuthorizeService';
import ProjectBasicDescription from './component/ProjectBasicDescription';
import Loading from '../../PageLayout/Loading';
import ClassicTitledTile from './component/ClassicTitledTile.jsx';
import DevOpsFileLink from './component/DevOpsFileLink';
import { withRouter } from "react-router-dom";
import logo from "images/codai.svg";
import projectImagePlaceholder from "images/projectImagePlaceholder.svg";

class ProjectOverviewPage extends Component {
  static propTypes = {
    match: ReactRouterPropTypes.match.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      projectId: props.match?.params?.id,

      availableTags: [],
      availableRoles: [],
      isUserDataScientist: false,
      isUserAdmin: false,
      currentUser: null,
      projectDetail: null,
      azureDevOps: [],
      isDevOpsUser: false,
      relatedProjects: [],
      relatedProjectsImages: {},
      dataset: [],

      project: {},
    };
  }

  componentDidUpdate() {
    if (this.props.match?.params?.id != this.state.projectId) {
      this.setState({ isLoading: true, projectId: this.props.match?.params?.id }, this.requestProjectData);
    }
  }

  componentDidMount() {
    this.requestAllPageData();
  }

  requestAllPageData() {
    const apiRequest = [
      ApiService.getRef(),
      UserService.IsUserDataScientist(),
      AuthorizeService.getUser(),
      UserService.IsUserAdmin()
    ];

    Promise.all(apiRequest).then((data) => {
      let stateUpdate = {
        availableRoles: data[0].profileTypeRefs,
        availableTags: data[0].tagRefs,
        isUserDataScientist: data[1],
        currentUser: data[2],
        isUserAdmin: data[3],
      };
      this.setState(stateUpdate, this.requestProjectData);
    });
  }

  requestProjectData() {
    if (!this.state.projectId) {
      return;
    }

    const apiRequest = [
      ApiService.getProject(this.state.projectId),
    ];
    Promise.all(apiRequest).then((data) => {
      let stateUpdate = {
        isLoading: false,
        projectDetail: data[0].project,
        azureDevOps: data[0].ado,
        dataset: data[0].aml.datasets,
        isProjectMember: data[0].project.projectUsers.findIndex(user => user.user.upn === this.state.currentUser.preferred_username) !== -1,
        isUserProjectAdmin: data[0].project.projectUsers.findIndex(user =>
          (user.profileTypeRefId === 'ADMIN') && user.user.upn === this.state.currentUser.preferred_username) !== -1
      };
      this.setState(stateUpdate);

      ApiService.projectSearch({
        "costCenterId": [],
        "creationDateFrom": null,
        "creationDateTo": null,
        "limit": 4,
        "orderBy": "name",
        "requesterStar": false,
        "searchText": "",
        "tagId": data[0].project.projectTags.map(tag => tag.tagId),
        "userEmail": []
      }).then((relatedProjects) => {
        relatedProjects = relatedProjects.filter(project => project.project.projectId !== parseInt(this.state.projectId)).slice(0, 3);

        // get related project images
        relatedProjects.forEach((project) => {
          ProjectService.getProjectImage(project.project.projectId)
            .then(imageUrl => {
              let newRelatedProjectsImages = { ...this.state.relatedProjectsImages };
              newRelatedProjectsImages[project.project.projectId] = imageUrl;
              this.setState({ relatedProjectsImages: newRelatedProjectsImages });
            })
            .catch((error) => {
              let newRelatedProjectsImages = { ...this.state.relatedProjectsImages };
              newRelatedProjectsImages[project.project.projectId] = projectImagePlaceholder;
              this.setState({ relatedProjectsImages: newRelatedProjectsImages });
              clearTimeout(error.errorDisplayTimer);
            });
        });
        this.setState({ relatedProjects });
      });
    });
  }

  render() {
    const isPrivate = this.state.projectDetail?.private;
    // const statusTags = this.state.availableTags.filter(t => t.tagTypeRefId === 'status');
    let projectOverview;

    if (this.state.isLoading) {
      projectOverview = (<Loading />);
    } else {
      const markdown = {
        context: this.state.azureDevOps.sourceFiles.find(f => f.fileName === 'context.md'),
        problematic: this.state.azureDevOps.sourceFiles.find(f => f.fileName === 'problematic.md'),
        result: this.state.azureDevOps.sourceFiles.find(f => f.fileName === 'results.md'),
      };

      projectOverview = (
        <>
          <ProjectBasicDescription
            project={this.state.projectDetail}
            projectMarkdownDescription={this.state.azureDevOps.sourceFiles.find(f => f.fileName === 'description.md')}
            availableTags={this.state.availableTags}
            availableRoles={this.state.availableRoles}
            isUserAdmin={(this.state.isUserProjectAdmin || this.state.isUserAdmin)}
            isUserDataScientist={(this.state.isUserProjectAdmin || this.state.isUserAdmin) || this.state.isUserDataScientist}
            isDevOpsUser={this.state.isUserProjectAdmin || this.state.isProjectMember}
            headerSection={(!this.state.isProjectMember && !(this.state.isUserProjectAdmin || this.state.isUserAdmin)) ? null : (
              <Col className="projectTitleButton">
                <Button {...LinkTo(`/project/${this.state.projectDetail.projectId}/details`)}><i className="icon-eye" /> Access to the details view</Button>
              </Col>
            )}
          />
          <div>
            <div>
              <Container>
                <Row>
                  <Col sm={6}>
                    <ClassicTitledTile title={(
                      <h3 className="bigTitledTile">
                        Context & Stakes{' '}
                        {(this.state.projectDetail.videoUrl !== null) ? <iframe width="530" height="360" src={this.state.projectDetail.videoUrl} allowfullscreen title="projectDetailVideo"></iframe> : null}

                        <span className="edit-section">
                          {this.state.isProjectMember && markdown.context && (<DevOpsFileLink project={this.state.projectDetail} devOpsPath={markdown.context.relPath} />)}
                        </span>

                      </h3>
                    )}>
                      {(isPrivate && !this.state.isProjectMember) ? <span className="confidentialImg">Confidential</span> :
                        markdown.context && markdown.context && markdown.context.content.length > 0 &&
                        <Markdown projectId={this.state.projectDetail.projectId} path={markdown.context.relPath}>{markdown.context.content}</Markdown>
                      }
                    </ClassicTitledTile>
                    <ClassicTitledTile title={(
                      <h3 className="bigTitledTile">
                        Main questions of the problematic{' '}
                        <span className="edit-section">
                          {(this.state.isProjectMember && markdown.problematic) && (<DevOpsFileLink project={this.state.projectDetail} devOpsPath={markdown.problematic.relPath} />)}
                        </span>
                      </h3>
                    )}>
                      {(isPrivate && !this.state.isProjectMember) ? <span className="confidentialImg">Confidential</span> :
                        markdown.problematic && markdown.problematic && markdown.problematic.content.length > 0 &&
                        <Markdown projectId={this.state.projectDetail.projectId} path={markdown.problematic.relPath}>{markdown.problematic.content}</Markdown>
                      }
                    </ClassicTitledTile>
                  </Col>
                  <Col sm={6}>
                    <ClassicTitledTile title={(<h3 className="bigTitledTile">Related items</h3>)}>
                      {this.state.relatedProjects.map((project, i) => {
                        const descriptionMarkdown = project.project.devOpsDescription;

                        return (
                          <Container className={'relatedItems'} key={i}>
                            <Row>
                              <Col sm={0}>
                                <img className='image' alt='project' src={this.state.relatedProjectsImages[project.project.projectId] ? this.state.relatedProjectsImages[project.project.projectId] : ''} />
                              </Col>
                              <Col sm={true}>
                                <span className='title'>{project.project.name}</span><br />
                                {descriptionMarkdown && descriptionMarkdown.length > 0
                                  ? <Markdown projectId={project.project.projectId} maxSize={100} >{descriptionMarkdown}</Markdown>
                                  : <p>{project.project.description}</p>
                                }
                                <Link to={'/project/' + project.project.projectId}>{'Project overview'}</Link>
                              </Col>
                            </Row>
                          </Container>
                        );
                      })}
                    </ClassicTitledTile>
                  </Col>
                </Row>
                <ClassicTitledTile title={(
                  <h3 className="bigTitledTile">
                    Results{' '}
                    <span className="edit-section">
                      {(this.state.isProjectMember && markdown.result) && (<DevOpsFileLink project={this.state.projectDetail} devOpsPath={markdown.result.relPath} />)}
                    </span>
                  </h3>
                )}
                >
                  {(isPrivate && !this.state.isProjectMember) ? <span className="confidentialImg">Confidential</span> :
                    markdown.result && markdown.result.content.length > 0 &&
                    <Markdown projectId={this.state.projectDetail.projectId} path={markdown.result.relPath}>{markdown.result.content}</Markdown>
                  }
                </ClassicTitledTile>
              </Container>
            </div>
          </div>
        </>
      );
    }

    return (
      <MainPagesLayout className='ProjectOverviewPage'>
        <Breadcrumb className={'breadCrumb'}>
          <Breadcrumb.Item {...LinkTo('/', true)}>
            <img alt="CoDAI" src={logo} />
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {this.state.projectDetail ? this.state.projectDetail.name : 'Project overview'}
          </Breadcrumb.Item>
        </Breadcrumb>
        {projectOverview}
      </MainPagesLayout>
    );
  }
}

export default withRouter(ProjectOverviewPage);
